/* eslint-disable max-len */
import { PetAvatars, UserContactInfoCard } from "../../../components";
import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

/* eslint-disable operator-linebreak */
import {
  BookingWhenContainer,
} from "./BookingReviewStyle";
import { CREATE_BOOKING_TYPE } from "../../../config/params";
import NewEditIcon from "../../../components/Icons/NewEditIcon";
import PromoCodeApply from "./PromoCodeApply";
import { fromUnixToFullDateNum } from "../../../utils/unix-timestamp";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import { useUserStore } from "../../../hooks/redux-hooks/user-store/user.store";
import { CalendarIcon, ExpressServiceAddressIcon, VerticalDivider } from "../../../components/Icons";
import { formatPetNames } from "../../../components/AvailableTimeSlots/ExpressAvailableTimeSlots";
import BookingReviewDetails from "../../../components/BookingReviewDetails/BookingReviewDetails";
import { useBookingAppointmentTypeStore, useBookingReasonsNavigation } from "../../../hooks";
import { userActivityLogger } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { getBookingMonth } from "../../../utils/bookingFlow";
import AvailableCredits from "./AvailableCredits";
type IBookingReviewContainer = {
  activeStep?: number;
  newUserBooking?: boolean | undefined;
  selectedSlot: string;
  setActiveStep: (val: number) => void
};

const BookingReviewContainer = (props: IBookingReviewContainer) => {
  const {
    selectedSlot, setActiveStep,
  } = props;
  const { appointmentForm, selectedPets, setAppointmentsForm } =
    useAppointmentStore();
  const { user } = useUserStore();
  const [bookingDate, setBookingDate]=useState<string>("");
  const { setDefaultNavigationValues }=useBookingReasonsNavigation();
  const { bookingAppointmentType } = useBookingAppointmentTypeStore();

  const [availableDate, setAvailableDate]=useState< {
    weekday: string;
    month: string;
    day: string;
    year: string;
    time: string;
}>();

  const handleEditTimeSlot = ()=>{
    setDefaultNavigationValues();
    setAppointmentsForm(null);
    userActivityLogger(MIXPANEL_EVENTS.USER_CLICK_EDIT_DETAILS,
      { pet_name: selectedPets.map((pet) => pet.name).join(","),
        type: "edit_timeslot",
        appt_type: bookingAppointmentType === CREATE_BOOKING_TYPE.DROPOFF_BOOKING ?
          "drop_off" :bookingAppointmentType === CREATE_BOOKING_TYPE.EXPRESS_BOOKING ? "express_visit" : "in_room_visit",
      });
    setActiveStep(1);
  };

  useEffect(()=>{
    if (appointmentForm?.time) {
      const availableDate = fromUnixToFullDateNum(+appointmentForm?.time!, "UTC");

      setAvailableDate(availableDate);
      setBookingDate(`${availableDate.month} ${availableDate.day} ${availableDate.year} `);
    }
  }, [appointmentForm?.time]);


  return (
    <div className="w-full flex flex-col gap-3 pb-2  p-3 border border-taupe-50 rounded-xl">
      <div className="flex gap-2 justify-between items-center">
        <div className="text-lg w-4/6">
          Let’s confirm&nbsp;
          <span className="font-semibold">{formatPetNames(selectedPets.map((pet, index)=>pet.name ))}</span>  visit at:
        </div>
        <PetAvatars
          height={50}
          width={50}
          petDetails={selectedPets} />
      </div>
      <div className="flex p-3 gap-2 bg-taupe-15 rounded-lg">
        <div className="pt-0.5">
          <ExpressServiceAddressIcon />
        </div>
        <div className="flex flex-col gap-0.5 text-sm">
          <div className="capitalize font-semibold">{`Goodvets ${user?.location?.locationName}`}</div>
          <div>{user?.location?.address}</div>
        </div>
      </div>
      <div>
        <Typography variant="body1" className="!font-bold text-sm" gutterBottom>
          Scheduled For
        </Typography>
        <BookingWhenContainer>
          <div className="flex justify-between w-full">
            <div className="flex gap-4 items-center">
              <CalendarIcon width={24} height={24} color="black" />
              <div>
                {/* <Typography variant="h4" className="!py-4 !font-semibold"> */}
                <span className="font-semibold flex gap-1 py-3 text-sm items-center flex-wrap">
                  {availableDate?.weekday}
                  <VerticalDivider />
                  {appointmentForm && appointmentForm?.time && `${getBookingMonth(appointmentForm.time)} ${bookingDate.split(" ")[1]}`}{" · "}
                  {selectedSlot?.toUpperCase()}
                </span>
                {/* </Typography> */}
              </div>
            </div>
            <div
              className="grow flex justify-end items-center mt-1 cursor-pointer"
              onClick={handleEditTimeSlot}
            >
              <NewEditIcon width={18} height={18} />
            </div>
          </div>

        </BookingWhenContainer>
      </div>
      <div></div>
      <div>
        <Typography variant="body1" className="!font-bold text-sm" gutterBottom>
            Reason for Visit
        </Typography>
        <BookingReviewDetails
          setActiveStep={setActiveStep}
          modal="BookingReview"
        />
      </div>
      <div>
        <Typography variant="body1" className="!font-bold text-sm" gutterBottom>
            Your Contact Information
        </Typography>
        {user &&
            <UserContactInfoCard
              userFirstName={user.firstName}
              userLastname={user.lastName}
              userEmail={user.email}
              userPhoneNumber={user.phone}
            />
        }
      </div>

      <hr className="border-gray-3"/>
      {/* PromoCode Apply Component */}
      <PromoCodeApply />
      <hr className="border-gray-3" />
      <AvailableCredits />
    </div>
  );
};

export default BookingReviewContainer;
